if (!customElements.get('carousel-filters')) {
  customElements.define(
    'carousel-filters',
    class CarouselFilters extends HTMLElement {
      constructor() {
        super();
        this.filters = this.querySelectorAll('.ingredients-carousel__filters-link');

        this.carousels = document.querySelectorAll('ingredients-carousel');

        this.filters.forEach((filter) => {
          filter.addEventListener('click', this.filterClickHandler.bind(this, filter));
        });
      }

      filterClickHandler(filter) {
        const filterValue = filter.getAttribute('data-filter');

        this.filters.forEach((filter) => {
          filter.classList.remove('ingredients-carousel__filters-link--active');
        });

        this.carousels.forEach((carousel) => {
          carousel.classList.remove('ingredients-carousel__container--active');
        });

        filter.classList.add('ingredients-carousel__filters-link--active');
        document.getElementById(`${filterValue}-carousel`).classList.add('ingredients-carousel__container--active');
      }
    },
  );
}
